const addPlusSign = value => (value > 0 ? `+${value}` : value);

export const formatOdd = (odd, type) => {
    if (odd === undefined || (odd === 0 && type === 'moneyline')) {
        return 'NA';
    }
    return `${odd === 0 ? 'PK' : addPlusSign(odd)}`;
};

export const formatOddButtonJuice = (juice, playType) => {
    if (playType === 'single-value') {
        return 'Prop';
    }
    return playType === 'moneyline' ? 'ML' : addPlusSign(juice);
};

// Spread juice defaults to -110 when missing or 0 (no juice data available)
export const getSpreadJuice = spreadJuice => (spreadJuice && Number(spreadJuice) !== 0 ? Number(spreadJuice) : -110);
